module.exports = {
    ResizeSensor: require('./src/ResizeSensor'),
    ElementQueries: require('./src/ElementQueries')
};



//////////////////
// WEBPACK FOOTER
// ../~/css-element-queries/index.js
// module id = 63
// module chunks = 0